import { render, staticRenderFns } from "./EditTabAccount.vue?vue&type=template&id=2128b761"
import script from "./EditTabAccount.vue?vue&type=script&lang=js"
export * from "./EditTabAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports